export default __webpack_public_path__ + "static/media/230.7ed42e77.jpg";